import { find } from '@sama/micro-dash';
import { ViewMode } from '../../../../outputs/annotation/annotation-shared/state/root/annotation-state';
import {
  LocationExternal,
  LocationSource,
  Point2D,
  PointType,
  ShapeLocation,
  ShapeLocationExternal,
  TagLocation,
  VisibilityState,
} from '../../../../team-apis/otterdam/answers/shape-typings';

export type ShapeLocationState2D = ShapeLocationState<Point2D>;

export function getLocationForFrameNumber<T extends ShapeLocation<PointType>>(
  locations: T[],
  frameNum: number,
) {
  return find(locations, (l) => l.frame_number === frameNum);
}

export function isVisible<T extends ShapeLocation<PointType>>(
  location: T | undefined,
) {
  return !!location && location.visibility > 0;
}

export function shouldShowShape(
  visibility: VisibilityState,
  viewMode: ViewMode,
  isSelected: boolean,
) {
  return (
    visibility > 0 && viewMode !== 'none' && (isSelected || viewMode === 'all')
  );
}

export function isShapeLocationExternal<P extends PointType>(
  location: LocationExternal<P>,
): location is ShapeLocationExternal<P> {
  return 'points' in location;
}

export function isTagLocationExternal(
  location: LocationExternal<any>,
): location is TagLocation {
  return 'tags' in location;
}

export interface ShapeLocationState<P extends PointType>
  extends ShapeLocation<P> {
  extrapolation?: MlExtrapolation<P>;
}

export interface MlExtrapolation<P extends PointType> {
  points: P[][];
  source: LocationSource;
}
